import { SuborganizationEntity } from '@/types/organization/suborganization.entity';
import AxiosService from '@/api/ApiBase';

class SuborganizationService {
  getAll() {
    return AxiosService.get<SuborganizationEntity[]>(`user/suborganization`);
  }
  getByCode(code: string) {
    return AxiosService.get<SuborganizationEntity>(`user/suborganization/${code}`);
  }
}

export default new SuborganizationService();
